import React, { ReactElement } from 'react';
import { PinIcon } from '../icons/icons';

const Location: React.FC<{ className?: string }> = ({
  className,
}): ReactElement => (
  <a
    href="https://www.google.com/maps/place/Cabinet+Logopedie+NovaLogo/@45.7391213,21.22932,17z/data=!3m1!4b1!4m5!3m4!1s0x47455dde56fcdcb3:0x6578f23abbc532cb!8m2!3d45.73914!4d21.2315043"
    target="_blank"
    className={`cursor-pointer flex items-center ${className}`}
    rel="noreferrer"
  >
    <PinIcon />
    <span className="ml-1">Str. Cozia, nr. 36, ap.3, Timișoara</span>
  </a>
);

export default Location;
